import { render, staticRenderFns } from "./buy-now-login.vue?vue&type=template&id=1c5d667d&scoped=true&"
import script from "./buy-now-login.vue?vue&type=script&lang=js&"
export * from "./buy-now-login.vue?vue&type=script&lang=js&"
import style0 from "./buy-now-login.vue?vue&type=style&index=0&id=1c5d667d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5d667d",
  null
  
)

export default component.exports